import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'finish',
  title: 'Wheel Finishes',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
    {
      title: 'Manual Order',
      name: 'manualOrder',
      by: [{ field: 'order', direction: 'asc' }],
    },
  ],
  fields: [
    defineField({
      name: 'order',
      title: 'Order',
      type: 'number',
    }),
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'style',
      title: 'Style',
      type: 'finishStyle',
    }),
    defineField({
      name: 'abbreviation',
      title: 'Feed Abbreviation',
      type: 'string',
      description:
        'Optional short code used in place of the full finish name in the Google Merchant ' +
        'feed item ID (Google caps item IDs at 50 characters). Leave empty to keep using the ' +
        'full name. Google treats the item ID as a permanent identity, so changing this later ' +
        're-creates every affected set in Merchant Center and resets its performance history — ' +
        'set it once and leave it.',
      validation: (rule: any) =>
        rule
          .max(16)
          .regex(/^[A-Za-z0-9-]*$/, { name: 'letters, numbers and dashes only' }),
    }),
    defineField({
      name: 'slug',
      title: 'Slug',
      type: 'slug',
      description:
        'Wheel finish does not have dedicated page on the frontend. We are using this slug to generate URLs for the gallery pages filter ie. `?finish=anthracite`.',
      validation: (rule: any) => rule.required(),
      options: {
        source: 'name',
        maxLength: 50,
      },
    }),
  ],
})